import Checkbox from '@cartwhl/ui/atoms/Checkbox';
import Select from '@cartwhl/ui/atoms/Select';
import Slider from '@cartwhl/ui/atoms/Slider';
import Text from '@cartwhl/ui/base/Text';

import { useStore } from '../batchGenerationPromptStore';

const MODEL_OPTIONS = [
  {
    value: 'swing',
    label: 'Swing',
    description: 'Perfect for dynamic action oriented motions.',
  },
  {
    value: 'scoot',
    label: 'Scoot',
    description: 'Great for conversational, gestural and everyday motions.',
  },
];

export default function ModelAndSettingsSection() {
  const store = useStore();
  const { model, duration, loop } = store.state;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 sm:gap-6">
      <div className="flex min-w-0 flex-col gap-2.5">
        <Text variant="studio/body/medium/sm" className="text-primary">
          Select your model
        </Text>
        <Select
          items={MODEL_OPTIONS}
          value={model}
          onValueChange={(v) => store.updateModel(v as 'swing' | 'scoot')}
        />
      </div>
      <div
        className="flex min-w-0 flex-col gap-6"
        role="group"
        aria-label="Looping"
      >
        <Text variant="studio/body/medium/sm" className="text-primary">
          Looping
        </Text>
        <Checkbox
          id="batch-loop"
          checked={loop}
          label="Loop all motions"
          variant="checkbox"
          color="settings"
          setChecked={(checked) => store.updateLoop(checked)}
        />
      </div>
      {model === 'swing' && (
        <div className="flex min-w-0 flex-col gap-6">
          <div className="flex items-center justify-between gap-6">
            <Text variant="studio/body/medium/sm" className="text-primary">
              Duration <span className="text-secondary">(3-8s)</span>
            </Text>
          </div>
          <div className="flex items-center justify-between gap-6">
            <Slider
              currentValue={duration}
              onChange={(value) => store.updateDuration(value)}
              min={3}
              max={8}
              step={1}
              trackColor="player"
              rangeColor="blue"
              id="duration"
            />
            <Text
              variant="studio/body/medium/xs"
              className="bg-gray-15 dark:bg-gray-75 flex h-6 w-12 items-center justify-center rounded-lg tracking-tighter tabular-nums"
            >
              {duration}s
            </Text>
          </div>
        </div>
      )}
    </div>
  );
}
